type ItemTree = {
  title: string;
  key: number;
}[];

export const CarSizeTree: ItemTree = [
  {title: "小型车", key: 0 },
  {title: "中型车", key: 1 },
  {title: "中大型车", key: 2 },
];

export const SaveModeTree: ItemTree = [
  {title: "事故救援", key: 0 },
  {title: "非事故救援", key: 1 },
];

export const SaveTypeTree: ItemTree = [
  {title: "乘用车", key: 0 },
  {title: "商用车", key: 1 },
];
